/* RESPONSIBLE TEAM: team-messenger */

export const LEADS_AND_VISITORS_TARGET_TYPE = 'leads_and_visitors';
export const USER_TARGET_TYPE = 'users';
export const MOBILE_TARGET_TYPE = 'mobile_users';

export const LIGHT_THEME_TYPE = 'light';
export const DARK_THEME_TYPE = 'dark';
